import { render, staticRenderFns } from "./Recuperation.vue?vue&type=template&id=2d88f192&"
import script from "./Recuperation.vue?vue&type=script&lang=js&"
export * from "./Recuperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports